import LogoSvg, { ArrowLeftSvgIcon } from '@/assets/svg'
import { CircularIcon } from '@/components/fragments'
import { useNavigate } from 'react-router-dom'

interface AuthLayoutProps {
  title?: string
  subTitle?: string | React.ReactNode
  children: React.ReactNode
  hasBack?: boolean
  onBack?: () => void
}

export default function AuthLayout({
  title,
  subTitle,
  hasBack = false,
  onBack,
  children,
}: AuthLayoutProps) {
  const navigate = useNavigate()
  return (
    <section className='w-screen h-screen overflow-hidden grid place-content-center bg-[#F5F5F5]'>
      <section className='w-[98%] mx-auto md:w-[30rem] p-5 bg-white auth-shadow rounded-[1.5rem]'>
        {hasBack && (
          <CircularIcon
            onClick={() => {
              if (onBack) {
                onBack()
                return
              }
              navigate(-1)
            }}
            icon={ArrowLeftSvgIcon}
          />
        )}
        <div className='p-5 py-10 pb-20 md:px-10'>
          <div className='text-center mb-5'>
            <div className='flex justify-center'>
              <LogoSvg />
            </div>
            <h1 className='text-[#424242] text-lg SFProMedium mt-4'>{title}</h1>
            <span className='text-xs text-[#A3A3A3]'>{subTitle}</span>
          </div>
          {children}
        </div>
      </section>
    </section>
  )
}
